import { render } from "./SongData.vue?vue&type=template&id=742c6004&scoped=true"
import script from "./SongData.vue?vue&type=script&lang=js"
export * from "./SongData.vue?vue&type=script&lang=js"

import "./SongData.vue?vue&type=style&index=0&id=742c6004&scoped=true&lang=scss"

import exportComponent from "V:\\Personal\\Projects\\Code\\Emotion-Based-Music-Streaming-App-WEB\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-742c6004"]])

export default __exports__